import _ from "lodash";
import { injectReducer } from "store/reducers";
import withAsyncRouteLoading from "UIComponents/AsyncRouteLoadingHoc";
import SubMenuCurriculumWrapper from "Administrator/commonComponents/SubMenuCurriculumWrapper";
import { getNextMenuRoute } from "Administrator/modules/AdministratorModule";
import { getRelativePath } from "Utils";
import { ATTENDANCE_CONSTANTS } from "AttendanceDashboard/constants/stringConstants";
export default store => ({
  path: "periods",
  component: withAsyncRouteLoading(
    () =>
      Promise.all([
        import(/* webpackChunkName: "admin-periodsSetup" */ "./components"),
        import(
          /* webpackChunkName: "admin-periodsSetup" */ "./modules/PeriodsModule"
        ),
      ]).then(([importedModule0, importedModule1]) => {
        const component = importedModule0.default;
        const module2 = importedModule1;
        const reducer = module2.default;
        const key = module2.NAME;
        injectReducer(store, {
          key,
          reducer,
        });
        return component;
      })
    //.catch(err => {
    //   throw err;
    // })
  ),
  onEnter(nextState, replace) {
    if (_.last(nextState.routes).path == ATTENDANCE_CONSTANTS.PERIODS) {
      const route = getNextMenuRoute(ATTENDANCE_CONSTANTS.PERIODS_SETUP);
      if (route) {
        replace(getRelativePath(route));
      } else {
        replace(getRelativePath("../"));
      }
    }
  },
  childRoutes: [SubMenuCurriculumWrapper(store)],
});
